'use client';

import styles from '@/app/components/Header.style';
import { useGlobalInfo } from '@/app/contexts/GlobalInfoContext';

import { Grid, Skeleton } from 'antd';
import { useRouter } from 'next/navigation';

/**
 * Este componente renderiza la cabecera de la aplicación.
 * Muestra un título y un botón para volver a la página anterior.
 * El título se obtiene del contexto global de la aplicación.
 * El botón de retroceso se oculta si la propiedad `hideBackButton` del contexto global es verdadera.
 * Mientras se carga el título, se muestra un esqueleto de carga.
 *
 * @returns {JSX.Element} El componente de la cabecera.
 */
export function Header() {
  const { globalInfo } = useGlobalInfo();
  const router = useRouter();
  const screens = Grid.useBreakpoint();

  const handleBack = () => {
    router.back();
  };

  // Sincroniza con .main-container: desktop 1320/16px, tablet 1024/12px, mobile 100%/8px
  const isMobile = screens.xs && !screens.md;
  const isTablet = screens.md && !screens.lg;
  const headerPadding = isMobile ? '14px 8px' : isTablet ? '14px 12px' : '14px 16px';

  const responsiveHeaderBoxStyle = {
    ...styles.main__headerBox,
    boxSizing: 'border-box',
    maxWidth: isTablet ? '1024px' : '1320px',
    padding: headerPadding
  } as React.CSSProperties;

  return (
    <header style={styles.main__header}>
      <div style={responsiveHeaderBoxStyle}>
        {globalInfo.title ? (
          <>
            {globalInfo.hideBackButton ? null : (
              <button onClick={handleBack} style={styles.backButton} aria-label='Volver'>
                <i className='bi bi-arrow-left' style={styles.backButton__icon}></i>
              </button>
            )}
            <h4>{globalInfo.title}</h4>
          </>
        ) : (
          <Skeleton.Input active style={{ width: 120 }} />
        )}
      </div>
    </header>
  );
}
